import styled from "styled-components";
import { FriendListTopBg } from "@assets";

export const RootContainer = styled.div`
	position: relative;
	margin: 0;
	display: flex;
	flex-direction: column;
	gap: 0;
`;

export const SpinWrapper = styled.div`
	height: ${props => props.page === 1 ? 'calc(100vh - 90px)' : 'auto'};
	display: flex;
	justify-content: center;
	align-items: center;
	padding-top: ${props => props.page === 1 ? '0' : '10px'};
`;

export const OuterDiv = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 16px;

	padding: 16px;
	border-radius: 16px;
	background: #F7F7F7;
	margin-bottom: 4px;
`;

export const InfoText = styled.span`
word-break: break-all;
`;

export const DateText = styled.span`
	color: #E39401;
	font-size: 14px;
	font-style: normal;
	font-weight: 700;
	line-height: 24px; /* 171.429% */
`;

export const FriendInfo = styled.div`
	display: flex;
	flex-direction: column;

	color: #1C1C1C;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px; /* 171.429% */
`;

export const IndexNumber = styled.div`
	color: #f9f9f9;
	display: flex;
	gap: 7px;
	flex: 1;
`;

export const Number = styled.div`
	font-weight: 400;
	font-size: 16px;
	color: #5d5189;
`;

export const FriendListWrapper = styled.div`
	width: calc(100% - 32px);
	margin: 0 auto;
`;

export const TitleDiv = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 10px;
`;

export const TitleWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	gap: 5px;

	text-align: center;
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: 30px; /* 150% */
`;

export const Title = styled.p`
	color: #1C1C1C;

`;

export const SubTitle = styled.p`
	color: #E39401;
`;

export const NoFriendListWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 0;
	height: 70vh;
`;

export const NoFriendText = styled.p`
	color: #979797;
	text-align: center;
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: 30px; /* 150% */
`;


export const TopImage = styled.div`
	background-image: url(${FriendListTopBg});
	background-size: cover;
	background-repeat: no-repeat;
	background-position: bottom;

	width: 100%;
	height: 255px;
`